import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {getJournal, getTranslations, journalAsyncActions} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import {ReactComponent as XpeditionIcon} from 'assets/image/menu-auth/DISCOVERY_GABI1.svg';
import {Link, useParams} from 'react-router-dom';
import {BotMode} from '@wholesalechange/chatcomponent';

import './styles.scss';

export const JournalChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    journal
  } = useSelector((state: IStore) => state.journal);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const {journalId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (journalId) {
      dispatch(journalAsyncActions[getJournal](Number(journalId)));
    }
  }, [journalId]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/journals">
        <FormattedMessage
          id={'gritx.journals.breadcrumb.previous'}
          defaultMessage="Journals"
        />
      </Link> {journal && <span className="journal__title-dialogue-name"> - {journal.dialogName}</span>}
    </div>;
  }

  return <div className="journal">
    {
      !loading.includes(getTranslations) && journal && <>
        <h1 className="journal__title">
          <XpeditionIcon className="journal__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={journal.dialogId}
          title={journal.dialogName}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
